module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-top-metals.b3029734.png";